import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * useAuthStore
 *
 * Zustand store that mirrors the auth/user slice of AuthContext.
 * V2 components read email / accessToken / orgMetaData from here
 * instead of AuthContext so they only re-render when auth data changes,
 * not on every unrelated AuthContext update.
 *
 * AuthContext syncs into this store after every state change, so both
 * V1 (context) and V2 (store) consumers always see the same data.
 */
const useAuthStore = create(
  devtools(
    (set) => ({
      // ── State ─────────────────────────────────────────────────────────────
      email:        localStorage.getItem('username') || null,
      profileName:  localStorage.getItem('name') || '',
      accessToken:  localStorage.getItem('access_token') || null,
      refreshToken: localStorage.getItem('refresh_token') || null,
      orgId:        null,
      orgDomains:   [],
      orgMetaData:  [],
      hqCurrency:   'USD',

      // ── Actions ───────────────────────────────────────────────────────────
      setEmail:        (email)        => set({ email }, false, 'setEmail'),
      setProfileName:  (profileName)  => set({ profileName }, false, 'setProfileName'),
      setAccessToken:  (accessToken)  => set({ accessToken }, false, 'setAccessToken'),
      setRefreshToken: (refreshToken) => set({ refreshToken }, false, 'setRefreshToken'),
      setOrgId:        (orgId)        => set({ orgId }, false, 'setOrgId'),
      setOrgDomains:   (orgDomains)   => set({ orgDomains }, false, 'setOrgDomains'),
      setOrgMetaData:  (orgMetaData)  => set({ orgMetaData }, false, 'setOrgMetaData'),
      setHqCurrency:   (hqCurrency)   => set({ hqCurrency }, false, 'setHqCurrency'),

      clearAuth: () =>
        set(
          { email: null, profileName: '', accessToken: null, refreshToken: null, orgId: null, orgDomains: [], orgMetaData: [], hqCurrency: 'USD' },
          false,
          'clearAuth',
        ),
    }),
    { name: 'Auth Store', anonymousActionType: 'auth' },
  ),
);

export default useAuthStore;
